/* Lashthing 2026-09-15: de "bolletjes" (how to apply) op de XL-starterkits.
 * Zelfde clips als op de kies-je-look-pagina: aanbrengen, verwijderen, DIY.
 * Klik op een bolletje opent de clip in een eenvoudige overlay; Escape of klik buiten sluit.
 * Zonder JS blijven het gewone links naar de video, er breekt niets. */
(function () {
  'use strict';

  var root = document.querySelector('[data-lt-circles]');
  if (!root) return;

  var overlay, video, titel;

  function bouwOverlay() {
    overlay = document.createElement('div');
    overlay.className = 'lt-circles__overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.hidden = true;
    overlay.style.display = 'none';
    overlay.innerHTML =
      '<div class="lt-circles__dialog">' +
        '<button type="button" class="lt-circles__close" aria-label="Sluiten">&times;</button>' +
        '<p class="lt-circles__titel" data-lt-circles-titel></p>' +
        '<video class="lt-circles__video" data-lt-circles-video playsinline controls preload="none"></video>' +
      '</div>';
    document.body.appendChild(overlay);
    video = overlay.querySelector('[data-lt-circles-video]');
    titel = overlay.querySelector('[data-lt-circles-titel]');
    /* 18-09 (melding Thomas: je komt er moeilijk uit). De clip vult op een telefoon bijna het hele
       scherm, dus van de achtergrond bleef alleen een randje van 16 px over. Nu sluit alles behalve
       de video zelf: de titel, de ruimte eromheen en de achtergrond. De video houdt zijn eigen
       bediening, dus pauzeren en spoelen blijft gewoon werken. */
    overlay.addEventListener('click', function (e) {
      if (e.target === video) return;
      sluit();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) sluit();
    });
  }

  /* 2026-09-21 (melding Thomas: tutorial gaat niet meer dicht). De overlay werd alleen
     met het hidden-attribuut verborgen, maar .lt-circles__overlay heeft display:flex in de
     CSS en die regel wint van het browserregeltje [hidden]{display:none}. Sluiten deed dus
     niets zichtbaars: de video werd wel gestopt, maar het zwarte scherm bleef staan over de
     hele pagina. Zichtbaarheid gaat nu expliciet via display, zodat het niet meer van de
     volgorde van de stylesheets afhangt. */
  function zetZichtbaar(aan) {
    overlay.hidden = !aan;
    overlay.style.display = aan ? 'flex' : 'none';
  }

  function open(btn) {
    if (!overlay) bouwOverlay();
    titel.textContent = btn.getAttribute('data-titel') || '';
    video.poster = btn.getAttribute('data-poster') || '';
    video.src = btn.getAttribute('data-src') || '';
    zetZichtbaar(true);
    document.documentElement.classList.add('lt-circles-open');
    var p = video.play();
    if (p && p.catch) p.catch(function () { /* autoplay geblokkeerd: gebruiker drukt zelf op play */ });
  }

  function sluit() {
    if (!overlay) return;
    video.pause();
    video.removeAttribute('src');
    video.load();
    zetZichtbaar(false);
    document.documentElement.classList.remove('lt-circles-open');
  }

  root.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-lt-circle]') : null;
    if (!btn) return;
    e.preventDefault();
    open(btn);
  });
})();
